import component from './zh-CN/component';
import globalHeader from './zh-CN/globalHeader';
import loading from './zh-CN/loading';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import promoVideo from './zh-CN/promoVideo';
import siteAnalytics from './zh-CN/siteAnalytics';
import pwa from './zh-CN/pwa';
import questionModal from './zh-CN/questionModal';
import reviews from './zh-CN/reviews';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  ...pages,
  ...promoVideo,
  ...siteAnalytics,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...loading,
  ...questionModal,
  ...reviews,
  // Ensure todaymall settings submenu keys are present for zh-CN (menu label for Island/Mountain Cost)
  'menu.todaymall.settings.island-mountain-cost': '岛屿/山区费用',
};
